export default __webpack_public_path__ + "static/media/Rick-and-Morty-Memes.ddfec2f8.jpg";